import React from 'react';
import { isActiveCustomer } from '../utils/CustomerUtil';

const SubscriptionStatus = ({ plan, renewalDate, price }) => {
  const { statusText, color } = isActiveCustomer(plan, renewalDate, price);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div
        title={statusText} // Tooltip on hover
        style={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          borderColor: '#172B4C',
          borderStyle: 'solid',
          borderWidth: '1px',
          backgroundColor: color, // Use color returned from isActiveCustomer
          cursor: 'help'
        }}
      />
    </div>
  );
};

export default SubscriptionStatus;
